var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { Box, Button, HFlex, MenuAction, MenuItem, Navbar, NavbarCollapse, NavbarLogo, NavbarMenu, NavbarMenuItem, NavbarMenuLink, TooltipOnHover, tombac, useTombac, } from "tombac";
import { ForwardIcon, WhatsNewIcon } from "tombac-icons";
import { trackEvent as track } from "../../Tracking";
import { TrialBadge } from "../../components/Trial";
import { useLegoland } from "../LegolandContext";
import { useLogoutMutation } from "../authApi/authApiHooks";
import { useMeDetailsQuery, useUserProduct } from "../legolandApi";
import { useReleaseNotesStatus } from "../releaseNotes";
import { GuideButton } from "./GuideButton";
import { Dot, IconButton } from "./IconButton";
import { LegolandNavbarApps } from "./LegolandNavbarApps/LegolandNavbarApps";
import { LegolandNavbarLimits } from "./LegolandNavbarLimits";
import { LegolandNavbarMe } from "./LegolandNavbarMe";
import { LegolandNavbarApiKeyModal } from "./LegolandNavbarApiKeyModal";
var Container = styled(Navbar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .TombacIcon {\n    box-sizing: content-box;\n    display: block;\n    height: ", ";\n    width: ", ";\n  }\n"], ["\n  .TombacIcon {\n    box-sizing: content-box;\n    display: block;\n    height: ", ";\n    width: ", ";\n  }\n"])), tombac.unit(24), tombac.unit(24));
var HintText = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  &:last-child {\n    margin-right: ", ";\n  }\n"], ["\n  ", "\n\n  &:last-child {\n    margin-right: ", ";\n  }\n"])), tombac.altText({
    color: tombac.color("neutral", 600),
    fontSize: 14,
    fontWeight: 500,
}), tombac.space(3));
var Subtitle = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  justify-content: baseline;\n  white-space: nowrap;\n"], ["\n  align-items: center;\n  display: flex;\n  justify-content: baseline;\n  white-space: nowrap;\n"])));
export var LegolandNavbar = function (_a) {
    var _b, _c, _d;
    var authHintText = _a.authHintText, _e = _a.breakpoint, breakpoint = _e === void 0 ? 768 : _e, children = _a.children, manualUrl = _a.manualUrl, meMenuBreakpoint = _a.meMenuBreakpoint, onGuidedTour = _a.onGuidedTour, productName = _a.productName, _f = _a.showSignIn, showSignIn = _f === void 0 ? true : _f, _g = _a.showSignUp, showSignUp = _g === void 0 ? false : _g, trackingCategory = _a.trackingCategory, rest = __rest(_a, ["authHintText", "breakpoint", "children", "manualUrl", "meMenuBreakpoint", "onGuidedTour", "productName", "showSignIn", "showSignUp", "trackingCategory"]);
    var isMaxSizeM = useMediaQuery({ maxWidth: breakpoint });
    var tombac = useTombac();
    var _h = useLegoland(), legolandUiUrl = _h.legolandUiUrl, Link = _h.Link, releaseNotesUrl = _h.releaseNotesUrl;
    var releaseNotesStatus = useReleaseNotesStatus();
    var _j = __read(useState(false), 2), isOpenApiKeyModal = _j[0], setIsOpenApiKeyModal = _j[1];
    var meDetailsQuery = useMeDetailsQuery();
    var logout = useLogoutMutation().mutate;
    var isAuthenticated = meDetailsQuery.isSuccess && meDetailsQuery.data.meDetails;
    var meProducts = (_c = (_b = meDetailsQuery === null || meDetailsQuery === void 0 ? void 0 : meDetailsQuery.data) === null || _b === void 0 ? void 0 : _b.meDetails) === null || _c === void 0 ? void 0 : _c.products;
    var isAnonymous = meDetailsQuery.isSuccess && !isAuthenticated;
    var userProduct = useUserProduct();
    productName = (_d = productName !== null && productName !== void 0 ? productName : userProduct === null || userProduct === void 0 ? void 0 : userProduct.displayName) !== null && _d !== void 0 ? _d : "";
    //openModal function that adds styles from shadowroot - ONLY temporary solution!
    // const openModal = () => {
    //   setTimeout(() => {
    //     let styles = document
    //       .getElementsByClassName(
    //         "playgroundPreview_docs-site-src-theme-Playground-styles-module"
    //       )[0]
    //       .getElementsByTagName("div")[0]
    //       .shadowRoot?.querySelector("style");
    //     styles &&
    //       document.getElementsByTagName("head")[0].appendChild(styles as any);
    //   }, 1000);
    // };
    var meMenuLinkProps = isAuthenticated
        ? [
            !meDetailsQuery.data.meDetails.isFallback
                ? {
                    as: Link,
                    children: "Settings",
                    className: "LegolandNavbar__settings",
                    href: "".concat(legolandUiUrl, "/settings"),
                    onClick: function () {
                        track("page_click", {
                            specificProps: {
                                component_name: "header",
                                component_sub_name: "settings-button",
                            },
                        });
                    },
                }
                : null,
            {
                as: "button",
                children: "Show API key",
                className: "LegolandNavbar__apikeyModal",
                onClick: function () {
                    // openModal(); // function that adds styles from shadowroot - ONLY temporary solution!
                    track("page_click", {
                        specificProps: {
                            component_name: "header",
                            component_sub_name: "show-api-button",
                        },
                    });
                    setIsOpenApiKeyModal(true);
                },
            },
            {
                $color: tombac.color("danger", 500),
                as: "button",
                children: "Sign out",
                className: "LegolandNavbar__sign-out",
                onClick: function () {
                    track("page_click", {
                        specificProps: {
                            component_name: "header",
                            component_sub_name: "logout-button",
                        },
                    });
                    logout();
                },
            },
        ].filter(Boolean)
        : [];
    var iconButtons = [];
    if (releaseNotesUrl)
        iconButtons.push({
            icon: React.createElement(WhatsNewIcon, null),
            label: "What's new?",
            props: {
                as: Link,
                href: releaseNotesUrl,
                onClick: function () {
                    track("page_click", {
                        specificProps: {
                            component_name: "header",
                            component_sub_name: "release-notes-button",
                        },
                    });
                },
            },
            showDot: releaseNotesStatus.isRead === false,
        });
    return (React.createElement(Container, __assign({ breakpoint: breakpoint }, rest),
        React.createElement(NavbarLogo, { as: "a", href: "/", title: productName && (React.createElement(Subtitle, null,
                productName,
                " ",
                userProduct !== undefined &&
                    !userProduct.isFallback &&
                    userProduct.access.status !== "DENIED" &&
                    userProduct.access.accessType === "EVALUATION" && (React.createElement(TrialBadge, { "$ml": "1sp" })))) }),
        (children || isAuthenticated) && (React.createElement(NavbarCollapse, { breakpoint: breakpoint },
            children,
            isMaxSizeM ? (React.createElement(React.Fragment, null,
                (iconButtons.length > 0 || manualUrl || onGuidedTour) && (React.createElement(NavbarMenu, { breakpoint: breakpoint },
                    iconButtons.map(function (button) { return (React.createElement(NavbarMenuItem, { key: button.label },
                        React.createElement(NavbarMenuLink, __assign({}, button.props),
                            button.label,
                            button.showDot && React.createElement(Dot, { breakpoint: breakpoint })))); }),
                    React.createElement(GuideButton, { asNavbarItems: true, manualUrl: manualUrl, onGuidedTour: onGuidedTour, track: track }))),
                React.createElement(NavbarMenu, { breakpoint: breakpoint }, meMenuLinkProps.map(function (props) { return (React.createElement(NavbarMenuItem, { key: props.className },
                    React.createElement(NavbarMenuLink, __assign({}, props)))); })))) : (React.createElement(HFlex, { alignItems: "center", h: "100%", marginLeft: "auto" },
                React.createElement(HFlex, { className: "MoveNavbar__icon-buttons" },
                    React.createElement(LegolandNavbarLimits, { track: track }),
                    iconButtons.map(function (button) { return (React.createElement(Box, { "$ml": "1sp", key: button.label },
                        React.createElement(TooltipOnHover, { content: button.label, placement: "bottom", size: "s", variant: "inverted" },
                            React.createElement(IconButton, __assign({}, button.props),
                                button.icon,
                                button.showDot && React.createElement(Dot, { breakpoint: breakpoint }))))); }),
                    React.createElement(Box, { "$ml": "1sp" },
                        React.createElement(GuideButton, { manualUrl: manualUrl, onGuidedTour: onGuidedTour, track: track }))),
                React.createElement(LegolandNavbarMe, { breakpoint: meMenuBreakpoint, menuItems: meMenuLinkProps.map(function (props) { return (React.createElement(MenuItem, { key: props.className },
                        React.createElement(MenuAction, __assign({}, props)))); }) }),
                React.createElement(LegolandNavbarApps, { track: track }))))),
        isAnonymous && (React.createElement(Box, { "$alignItems": "baseline", "$display": "flex", "$marginLeft": "auto", "$marginRight": "3sp" },
            authHintText && !isMaxSizeM && React.createElement(HintText, null, authHintText),
            showSignIn && (React.createElement(Button, { "$marginLeft": "3sp", append: React.createElement(ForwardIcon, null), appendedHoverEffect: "anim-forward", as: Link, className: "LegolandNavbar__sign-in", href: "".concat(legolandUiUrl, "/login").concat(legolandUiUrl ? "?redirect=".concat(window.location.toString()) : ""), onClick: function () {
                    return track("page_click", {
                        specificProps: {
                            component_name: "header",
                            component_sub_name: "login-button",
                        },
                    });
                }, variant: "primary" }, "Log in")),
            showSignUp && (React.createElement(Button, { "$marginLeft": "3sp", append: React.createElement(ForwardIcon, null), appendedHoverEffect: "anim-forward", as: Link, className: "LegolandNavbar__sign-up", href: "".concat(legolandUiUrl, "/register"), onClick: function () {
                    return track("page_click", {
                        specificProps: {
                            component_name: "header",
                            component_sub_name: "register-button",
                        },
                    });
                }, variant: "primary" }, "Register")))),
        React.createElement(LegolandNavbarApiKeyModal, { isOpen: isOpenApiKeyModal, products: meProducts, setIsOpen: setIsOpenApiKeyModal })));
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=LegolandNavbar.js.map